//@flow
import withSensors from "./withSensors"
import withSensorFormDetails from "./withSensorFormDetails"
import mutateUpdateSensor from "./mutateUpdateSensor"

const queries = {
  withSensors,
  withSensorFormDetails,
  mutateUpdateSensor
}

export default queries



// WEBPACK FOOTER //
// ./src/Sensors/queries/index.js